import { Flex } from '@chakra-ui/react';
import { Rabbit } from 'lucide-react';
import { FC } from 'react';
import { ContactUsLink } from '~/common/components/ContactUsLink';
import { CardEmptyState } from '../../../CardEmptyState';

export const MissingListPriceErrorState: FC = () => {
  return (
    <Flex h="100%" justifyContent="center" w="100%">
      <CardEmptyState
        description={
          <>
            We don't support listings without purchase price yet.
            <br />
            Please check back later or <ContactUsLink children="contact us" />{' '}
            if you believe this is an error.
          </>
        }
        icon={Rabbit}
        title="Listing Report Unavailable"
      />
    </Flex>
  );
};
